import {
    FETCH_NOTIFICATION_LIST_BEGIN,
    FETCH_NOTIFICATION_LIST_SUCCESS,
    FETCH_POST_NOTIFICATION_LIST_FAILURE
} from "../action/NotificationList";

const initialState = {
    notifications: [],
    loading: false,
    error: null
};

export default function NotificationListReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_NOTIFICATION_LIST_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_NOTIFICATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                notifications: action.payload.notifications,
            };

        case FETCH_POST_NOTIFICATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                notifications: []
            };
        default:
            return state;
    }
}
